export const HUBSPOT_PORTAL_ID = '7124858';
export const HUBSPOT_FORM_ID = '168ca782-4cb1-4d32-b17b-d44a63a4c83b';
